import { RISK } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function RiskDot({ level = "verde", size = "md", label = false, className }) {
  const r = RISK[level] || RISK.verde;
  const dim = size === "sm" ? "h-2 w-2" : size === "lg" ? "h-3.5 w-3.5" : "h-2.5 w-2.5";
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <span className={cn("rounded-full ring-4", dim, r.cls, r.ring)} />
      {label && <span className={cn("text-xs font-medium", r.text)}>{r.label}</span>}
    </span>
  );
}

export function ScoreBadge({ score = 0, color = "rosu" }) {
  const r = RISK[color] || RISK.rosu;
  return (
    <span
      data-testid="score-badge"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-bold tabular-nums ring-1",
        r.text,
        r.ring,
        "bg-white/[0.03]"
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", r.cls)} />
      {score}
    </span>
  );
}
